import request from "../utils/request";

// 定义接口返回数据类型
interface ResponseData<T = any> {
  code: number;
  data: T;
  message: string;
}

// 封装GET请求
export function get<T>(url: string, params?: object): Promise<ResponseData<T>> {
  return request({
    url,
    method: "get",
    params,
  });
}

// 封装POST请求
export function post<T>(url: string, data?: object): Promise<ResponseData<T>> {
  return request({
    url,
    method: "post",
    data,
  });
}

// 封装PUT请求
export function put<T>(url: string, data?: object): Promise<ResponseData<T>> {
  return request({
    url,
    method: "put",
    data,
  });
}

// 封装DELETE请求
export function del<T>(url: string, data?: object): Promise<ResponseData<T>> {
  return request({
    url,
    method: "delete",
    data,
  });
}
